export default [
    {
        path: "/login",
        name: "index-login",
        component: () => import("../../views/login/Login.vue"),
        meta: {
            title: "登录",
            authorization: false,
            configType: 1,
        },
    },
];
